import { useGetPublicDesilStatistik } from '@tatatemplate/shared-lib'

export function useDesilStats() {
  return useGetPublicDesilStatistik({
    query: { queryKey: ['desil', 'statistics'], staleTime: 5 * 60 * 1000, retry: 3 },
  })
}
